import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostBinding,
    inject,
    OnInit,
    Renderer2,
    ViewEncapsulation,
    input,
    OnDestroy,
} from '@angular/core';
import { TemplateObservable } from '@bazis/shared/classes/template-observable';
import { createPopper, flip, Instance, preventOverflow, hide, Modifier } from '@popperjs/core';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --padding-start: 0; --padding-end: 0; --padding-top: 0; --padding-bottom: 0; --border-radius: initial; --border-width: initial; --border-style: initial; --border-color: initial; --box-shadow: initial; --background: initial; --min-height: initial; --max-height: initial; --min-width: initial; --width: initial; --max-width: initial; --color: inherit; --font-size: inherit; --font-weight: inherit; --line-height: initial; --height-arrow: initial; --width-arrow: initial; --border-color-arrow: var(--background); display: none; box-sizing: border-box; padding-left: var(--padding-start); padding-right: var(--padding-end); padding-top: var(--padding-top); padding-bottom: var(--padding-bottom); border-radius: var(--border-radius); border-width: var(--border-width); border-style: var(--border-style); border-color: var(--border-color); box-shadow: var(--box-shadow); background: var(--background); min-height: var(--min-height); max-height: var(--max-height); min-width: var(--min-width); width: var(--width); max-width: var(--max-width); color: var(--color); font-size: var(--font-size); font-weight: var(--font-weight); line-height: var(--line-height); } :host .bazis-tooltip__arrow { position: absolute; } :host([data-show]) { display: block; } :host([data-popper-placement^=top]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[placement^=top]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[ng-reflect-placement^=top]) .bazis-tooltip__arrow { bottom: calc(var(--height-arrow) / -1); border-left: calc(var(--width-arrow) / 2) solid transparent; border-right: calc(var(--width-arrow) / 2) solid transparent; border-top: var(--height-arrow) solid var(--border-color-arrow); } :host([data-popper-placement^=bottom]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[placement^=bottom]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[ng-reflect-placement^=bottom]) .bazis-tooltip__arrow { top: calc(var(--height-arrow) / -1); border-left: calc(var(--width-arrow) / 2) solid transparent; border-right: calc(var(--width-arrow) / 2) solid transparent; border-bottom: var(--height-arrow) solid var(--border-color-arrow); } :host([data-popper-placement^=left]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[placement^=left]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[ng-reflect-placement^=left]) .bazis-tooltip__arrow { right: calc(var(--height-arrow) * -1); border-top: calc(var(--width-arrow) / 2) solid transparent; border-bottom: calc(var(--width-arrow) / 2) solid transparent; border-left: var(--height-arrow) solid var(--border-color-arrow); } :host([data-popper-placement^=right]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[placement^=right]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[ng-reflect-placement^=right]) .bazis-tooltip__arrow { left: calc(var(--height-arrow) * -1); border-top: calc(var(--width-arrow) / 2) solid transparent; border-bottom: calc(var(--width-arrow) / 2) solid transparent; border-right: var(--height-arrow) solid var(--border-color-arrow); } :host([data-popper-placement=top-start]) .bazis-tooltip__arrow, :host([data-popper-placement=bottom-start]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[placement=top-start]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[placement=bottom-start]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[ng-reflect-placement=top-start]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[ng-reflect-placement=bottom-start]) .bazis-tooltip__arrow { left: 11px; } :host([data-popper-placement^=top-end]) .bazis-tooltip__arrow, :host([data-popper-placement=bottom-end]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[placement^=top-end]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[placement=bottom-end]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[ng-reflect-placement^=top-end]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[ng-reflect-placement=bottom-end]) .bazis-tooltip__arrow { right: 11px; } :host([data-popper-placement=top]) .bazis-tooltip__arrow, :host([data-popper-placement=bottom]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[placement=top]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[placement=bottom]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[ng-reflect-placement=top]) .bazis-tooltip__arrow, :host(.bazis-tooltip_static[ng-reflect-placement=bottom]) .bazis-tooltip__arrow { left: 50%; transform: translateX(-50%); } :host([data-popper-reference-hidden]) { visibility: hidden; pointer-events: none; } :host(.bazis-tooltip_static) { --width: inherit; --width: max-content; position: absolute; transform: translateX(var(--offset-left)) translateY(var(--offset-top)); } :host(.bazis-tooltip_static[placement=top]), :host(.bazis-tooltip_static[ng-reflect-placement=top]) { top: 0; left: 50%; transform: translateX(-50%) translateY(calc(-100% - var(--offset-top))); } :host(.bazis-tooltip_static[placement=top-start]), :host(.bazis-tooltip_static[ng-reflect-placement=top-start]) { top: 0; left: 0; transform: translateX(var(--offset-left)) translateY(calc(-100% - var(--offset-top))); } :host(.bazis-tooltip_static[placement=top-end]), :host(.bazis-tooltip_static[ng-reflect-placement=top-end]) { top: 0; right: 0; transform: translateX(var(--offset-left)) translateY(calc(-100% - var(--offset-top))); } :host(.bazis-tooltip_static[placement=bottom]), :host(.bazis-tooltip_static[ng-reflect-placement=bottom]) { left: 50%; transform: translateX(-50%) translateY(var(--offset-top)); } :host(.bazis-tooltip_static[placement=bottom-end]), :host(.bazis-tooltip_static[ng-reflect-placement=bottom-end]) { right: 0; } :host(.bazis-tooltip_static[placement=left]), :host(.bazis-tooltip_static[ng-reflect-placement=left]) { top: 50%; right: 100%; transform: translateX(var(--offset-left)) translateY(-50%); } :host(.bazis-tooltip_static[placement=right]), :host(.bazis-tooltip_static[ng-reflect-placement=right]) { top: 50%; left: 100%; transform: translateX(var(--offset-left)) translateY(-50%); } :host(.bazis-tooltip_light) { --background: var(--bazis-background); --color: var(--bazis-text-color); }`,
);

@Component({
    selector: 'bazis-tooltip',
    template: `
        <div
            [hidden]="!arrow()"
            class="bazis-tooltip__arrow"
            data-popper-arrow
            part="arrow"
        ></div>
        <slot></slot>
    `,
    // styleUrls: ['tooltip.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TooltipElement implements OnInit, OnDestroy {
    public el = inject(ElementRef);

    private renderer = inject(Renderer2);

    // тот элемент который вызывает тултип
    readonly reference = input<Element>(undefined);

    // действие которое вызывает тултип, по умолчанию наведение
    readonly eventType = input<'hover' | 'click'>('hover');

    // расположение тултипа, по умолчанию снизу от начала вызывающего элемента.
    readonly placement = input<
        | 'auto'
        | 'auto-start'
        | 'auto-end'
        | 'top'
        | 'top-start'
        | 'top-end'
        | 'bottom'
        | 'bottom-start'
        | 'bottom-end'
        | 'right'
        | 'right-start'
        | 'right-end'
        | 'left'
        | 'left-start'
        | 'left-end'
    >('bottom-start');

    // включает слушатель изменения контента
    readonly watchChange = input<boolean>(false);

    readonly type = input<'dark' | 'light'>('dark');

    // смещение тултипа [x, y]
    readonly offset = input<[number, number]>([0, 4]);

    // разрешает клик внутри тултипа, не будет сворачивать его по этому клику
    readonly allowClickInside = input<boolean>(false);

    // Если тултип статичный, то не будет происходить его переориентирование по расположению
    // Возможно использование только при eventType = 'hover'
    // Наведение будет работать со стилями, без слушателей наведения
    // Статичный компонент тултипа, должен находиться внутри вызывающего родителя!!!
    readonly isStatic = input<boolean>(false);

    readonly arrow = input<boolean>(true);

    // modifiers поппера. В редких случаях, может понадобится более тонкая настройка.
    readonly modifiers = input<Partial<Modifier<any, any>>[]>([]);

    // TODO: необходим публичный метод, который будет закрывать тултип, если eventType = click (на clikcoutside)

    @HostBinding('attr.role') role: string = 'tooltip';

    @HostBinding('class') get tooltipClass() {
        return {
            [`bazis-tooltip_${this.type()}`]: !!this.type(),
            ['bazis-tooltip_static']: this.isStatic(),
        };
    }

    @HostBinding('style') get tooltipStyle() {
        if (!this.isStatic()) return;
        return {
            [`--offset-left`]: this.offset()[0] + 'px',
            [`--offset-top`]: this.offset()[1] + 'px',
        };
    }

    showEvents = ['mouseenter', 'focus'];

    hideEvents = ['mouseleave', 'blur'];

    instancePopper: Instance;

    isShown: TemplateObservable<boolean> = new TemplateObservable(false);

    showListen: (() => void)[] = [];

    hideListen: (() => void)[] = [];

    globalListen: () => void;

    // слушает изменения содержимого
    changeListen: () => void;

    ngOnInit(): void {
        const reference = this.reference();
        if (!reference) return;

        this.initStatic();

        if (this.eventType() === 'hover') {
            this.showEvents.forEach((event) => {
                this.showListen.push(
                    this.renderer.listen(this.reference(), event, () => this.show()),
                );
            });

            this.hideEvents.forEach((event) => {
                this.hideListen.push(
                    this.renderer.listen(this.reference(), event, () => this.hide()),
                );
            });
        } else {
            this.showListen.push(this.renderer.listen(reference, 'click', () => this.toggle()));

            this.globalListen = this.renderer.listen('document', 'click', (event) => {
                const clickedInside = this.reference().contains(event.target);
                if (this.isShown._ && !clickedInside && !this.allowClickInside()) {
                    this.renderer.removeAttribute(this.el.nativeElement, 'data-show');
                    this.isShown.set(!this.isShown._);
                }
            });
        }

        if (this.watchChange() && this.instancePopper) {
            this.changeListen = this.renderer.listen(
                this.el.nativeElement,
                'DOMCharacterDataModified',
                () => {
                    this.instancePopper.update();
                },
            );
        }

        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }

    ngOnDestroy(): void {
        if (this.instancePopper) this.instancePopper.destroy();
        // Remove listeners
        this.hideListen.forEach((fn) => fn());
        this.showListen.forEach((fn) => fn());
        if (this.globalListen) this.globalListen();
        if (this.changeListen) this.changeListen();
    }

    private show() {
        this.createPopper();
        this.renderer.setAttribute(this.el.nativeElement, 'data-show', '');

        // Enable the event listeners
        this.setEventListener(true);

        if (this.instancePopper) this.instancePopper.update();
        this.isShown.set(true);
    }

    private hide() {
        this.renderer.removeAttribute(this.el.nativeElement, 'data-show');

        // Disable the event listeners
        this.setEventListener(false);

        this.isShown.set(false);
    }

    private setEventListener(listen = true) {
        if (!this.instancePopper) return;
        // Disable the event listeners
        this.instancePopper.setOptions((options) => ({
            ...options,
            modifiers: [...options.modifiers, { name: 'eventListeners', enabled: listen }],
        }));
    }

    private initStatic() {
        if (!this.isStatic()) return;
        this.renderer.setStyle(this.reference(), 'position', 'relative');
    }

    private createPopper() {
        if (this.isStatic() || this.instancePopper) return;

        this.instancePopper = createPopper(this.reference(), this.el.nativeElement, {
            // options
            placement: this.placement(),
            strategy: 'fixed',
            modifiers: [
                ...this.modifiers(),
                preventOverflow,
                flip,
                hide,
                {
                    name: 'offset',
                    options: {
                        offset: this.offset(),
                    },
                },
                {
                    name: 'computeStyles',
                    options: {
                        gpuAcceleration: false, // true by default
                    },
                },
            ],
        });
    }

    private toggle() {
        if (this.isShown._) {
            this.hide();
        } else {
            this.show();
        }
    }
}
